import React from 'react';
import { Link } from 'react-router-dom';

const products = [
  {
    name: 'e-Padasalai',
    route: '/products/epadasalai',
    eyebrow: 'Education Technology',
    summary: 'A digital learning platform that brings lessons, resources, and school communication into one accessible experience.',
    icon: 'EP',
    features: ['Digital classroom resources', 'Structured learning content', 'Student and educator access', 'Scalable school technology'],
  },
  {
    name: 'TheKallos360',
    route: '/products/thekallos360',
    eyebrow: 'Beauty and Wellness Technology',
    summary: 'A complete digital platform for beauty and wellness businesses to present services, manage enquiries, and grow online.',
    icon: '360',
    features: ['Service and business showcase', 'Appointment enquiry journeys', 'Responsive customer experience', 'Search-ready digital presence'],
  },
];

const Products = () => (
  <>
    <section className="py-5 text-white" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <span className="badge bg-light text-primary mb-3">OUR PRODUCTS</span>
        <h1 className="display-5 fw-bold">Products built for real-world impact</h1>
        <p className="lead mb-0" style={{ color: '#dbeafe', maxWidth: 720 }}>
          Explore digital products shaped by EGB Systems for education, beauty, wellness, and growing businesses.
        </p>
      </div>
    </section>

    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row g-4">
          {products.map(product => (
            <div className="col-12 col-lg-6" key={product.route}>
              <article className="card border-0 shadow-sm h-100 p-4">
                <div className="d-flex align-items-center gap-3 mb-4">
                  <div className="rounded-3 bg-primary text-white d-flex align-items-center justify-content-center fw-bold" style={{ width: 64, height: 64 }}>
                    {product.icon}
                  </div>
                  <div>
                    <span className="text-primary small fw-semibold">{product.eyebrow}</span>
                    <h2 className="h4 fw-bold mb-0">{product.name}</h2>
                  </div>
                </div>
                <p className="text-muted">{product.summary}</p>
                <ul className="text-muted ps-3">
                  {product.features.map(feature => <li key={feature} className="mb-2">{feature}</li>)}
                </ul>
                <Link className="btn btn-primary mt-auto align-self-start" to={product.route}>View product</Link>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default Products;
